<div class="template-editor">
  <div class="editor-header">
    <h2>{{ isEdit ? 'Edit Template' : 'Create New Template' }}</h2>
    <button class="close-btn" (click)="onCancel()" type="button">×</button>
  </div>

  <form (ngSubmit)="onSubmit()" class="editor-form">
    <!-- Template Name -->
    <div class="form-group">
      <label for="template-name" class="form-label">Template Name *</label>
      <input
        id="template-name"
        type="text"
        [(ngModel)]="formData.name"
        name="name"
        class="form-input"
        placeholder="Enter template name"
        required
        maxlength="100">
    </div>

    <!-- Channel Selection -->
    <div class="form-group">
      <label for="template-type" class="form-label">Communication Channel *</label>
      <select
        id="template-type"
        [(ngModel)]="formData.template_type"
        name="template_type"
        class="form-select"
        (change)="onChannelChange()"
        required>
        <option *ngFor="let channel of channels" [value]="channel.value">
          {{ channel.label }}
        </option>
      </select>
    </div>

    <!-- Company Selection (only for Super Admin) -->
    <div class="form-group" *ngIf="isSuperAdmin()">
      <label for="mc-company" class="form-label">Company *</label>
      <select
        id="mc-company"
        [(ngModel)]="formData.mcCompanyId"
        name="mcCompanyId"
        class="form-select"
        required>
        <option value="">Select Company</option>
        <option *ngFor="let company of mcCompanies" [value]="company.id">
          {{ company.name }}
        </option>
      </select>
      <small class="form-help">Select which company this template applies to</small>
    </div>

    <!-- Email Subject (only for email templates) -->
    <div class="form-group" *ngIf="formData.template_type === 'email'">
      <label for="template-subject" class="form-label">Subject Line *</label>
      <input
        id="template-subject"
        type="text"
        [(ngModel)]="formData.subject"
        name="subject"
        class="form-input"
        placeholder="Enter email subject"
        required
        maxlength="200">
    </div>

    <!-- Template Body -->
    <div class="form-group">
      <label for="template-body" class="form-label">
        Message Content *
        <span class="character-count" [class.over-limit]="isOverLimit()">
          {{ getCharacterCount() }} / {{ getCharacterLimit() }} characters
        </span>
      </label>
      <textarea
        id="template-body"
        [(ngModel)]="formData.body"
        name="body"
        class="form-textarea template-body-input"
        [placeholder]="formData.template_type === 'email' ? 'Enter email body content...' : 
                     formData.template_type === 'whatsapp' ? 'Enter WhatsApp message...' : 
                     'Enter SMS message...'"
        (input)="onBodyChange()"
        required
        rows="6"
        #templateBodyInput></textarea>
      
      <div class="character-warning" *ngIf="isOverLimit()">
        ⚠️ Message exceeds recommended character limit for {{ formData.template_type.toUpperCase() }}
      </div>
    </div>

    <!-- Variable Suggestions -->
    <div class="form-group">
      <label class="form-label">Common Variables</label>
      <div class="variable-suggestions">
        <button
          *ngFor="let variable of commonVariables"
          type="button"
          class="variable-btn"
          (click)="insertVariable(variable.key)">
          {{ variable.display }}
        </button>
      </div>
    </div>

    <!-- Detected Variables -->
    <div class="form-group" *ngIf="variables.length > 0">
      <label class="form-label">Detected Variables</label>
      <div class="detected-variables">
        <span class="variable-tag" *ngFor="let variable of variables">
          {{variable}}
        </span>
      </div>
    </div>


    <!-- Action Buttons -->
    <div class="form-actions">
      <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isLoading">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="isLoading">
        <span *ngIf="isLoading">Saving...</span>
        <span *ngIf="!isLoading">{{ isEdit ? 'Update' : 'Create' }}</span>
      </button>
    </div>
  </form>
</div>